<template>
  <div class="statistics">
    <div class="row">
      <div class="key">问题数:</div>
      <div class="val">{{ statistics.num }}</div>
    </div>
    <div class="row">
      <div class="key">问题金额:</div>
      <div class="val">{{ statistics.kin.toFixed(2) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checkList: { type: Array },

  },
  computed: {
    statistics() {
      // console.log(this.checkList);
      let total = {
        num: 0,
        kin: 0,
      }
      this.checkList.forEach(item => {
        total.num += item.num
        total.kin += item.num * item.pre_price
      })
      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>